import styled from '@emotion/styled';
import { InfoIcon as InfoIconDefault } from 'static/icons';

export const InfoIcon = styled(InfoIconDefault)<{
  warning?: number;
  small?: number;
}>`
  color: ${({ theme, warning }) =>
    warning ? theme.colors.warning : theme.colors.highlight};
  width: ${({ theme, small }) => small && theme.textStyles.h2.fontSize};
  height: ${({ theme, small }) => small && theme.textStyles.h2.fontSize};
  display: inline;
`;
